import React from 'react';
import { Form, Formik } from 'formik';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import SplashScreenTemplate from 'components/SplashScreenTemplate/SplashScreenTemplate';
import FormikTextInput from 'components/forms/formik/FormikTextInput/FormikTextInput';
import SubmitButton from 'components/SubmitButton/SubmitButton';
import Markdown from 'components/Markdown/Markdown';
import { useSystemSettings } from 'providers/SystemSettingsProvider';

import useInitialValues from './hooks/useInitialValues';
import useLoginSubmit from './hooks/useLoginSubmit';
import useSchema from './hooks/useSchema';

import './LoginPage.scss';

const LoginPage = () => {
  const { t } = useTranslation();
  const { disable_client_login, disable_client_login_reason } = useSystemSettings();
  const initialValues = useInitialValues();
  const schema = useSchema();
  const onSubmit = useLoginSubmit();

  return (
    <SplashScreenTemplate className="enkrateia-login-page">
      {disable_client_login && disable_client_login_reason && (
        <div className="login-disabled-banner">
          <Markdown>{disable_client_login_reason}</Markdown>
        </div>
      )}
      <Formik initialValues={initialValues} validationSchema={schema} onSubmit={onSubmit}>
        <Form>
          <FormikTextInput label={t('pages.login.form.email')} name="email" type="email" fullWidth />
          <FormikTextInput label={t('pages.login.form.password')} name="password" type="password" fullWidth />
          <SubmitButton submitVariant="form" variant="primary">
            {t('pages.login.form.submit')}
          </SubmitButton>
        </Form>
      </Formik>
      <Link to="/register">{t('pages.login.form.needAccount')}</Link>
      <Link to="/reset-password">{t('pages.login.form.forgotPassword')}</Link>
    </SplashScreenTemplate>
  );
};

export default LoginPage;
